var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoConfirmCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4854 5.93934C18.0606 5.35355 18.9933 5.35355 19.5686 5.93934C20.1368 6.51794 20.1437 7.45163 19.5895 8.03894L11.7486 18.0195C11.7373 18.0339 11.7252 18.0476 11.7124 18.0607C11.1371 18.6464 10.2044 18.6464 9.62919 18.0607L4.43144 12.7678C3.85619 12.182 3.85619 11.2322 4.43144 10.6464C5.0067 10.0607 5.93937 10.0607 6.51463 10.6464L10.6264 14.8335L17.4463 5.98421C17.4584 5.96847 17.4715 5.95349 17.4854 5.93934Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoConfirmCheck);
export default __webpack_public_path__ + "static/media/ico-confirm_check.81f60eb1c0912e88bb363f2b648993e6.svg";
export { ForwardRef as ReactComponent };